import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { cloneDeep } from 'lodash';
import { CustomDataForProfileActions, ProfilePostActions } from 'mbs-ui-shared@models/rmm-custom-notification-model';
import { filter, take } from 'rxjs';
import { LoadRmmCustomNotificationWizardService } from '../../../../utility/load-rmm-custom-notification-wizard.service';

@UntilDestroy()
@Component({
  selector: 'mbs-common-profile-notification-settings',
  templateUrl: './common-profile-notification-settings.component.html'
})
export class CommonProfileNotificationSettingsAction implements OnChanges {
  @Input() enabled = false;
  @Input() includeConnectWise = false;
  @Input() postActions: ProfilePostActions = null;

  private data: CustomDataForProfileActions;
  private readonly commonKey = 'general';

  constructor(private loadRmmCustomNotificationWizardService: LoadRmmCustomNotificationWizardService) {
    this.loadData();
  }

  onPostActionChanged(data: CustomDataForProfileActions) {
    this.data = cloneDeep(data);

    if (!this.enabled || !data) return;

    this.loadRmmCustomNotificationWizardService.profileActionPayload.next({ general: cloneDeep(data.postActionPayload) });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.enabled = true;
      this.onPostActionChanged(this.data);
    }
  }

  loadData() {
    this.loadRmmCustomNotificationWizardService.profileActionPayload
      .pipe(
        filter((value) => value && this.commonKey in value),
        take(1)
      )
      .subscribe((postActions) => (this.postActions = cloneDeep(postActions)));
  }
}
